<template>
  <div class="bg-grey-academy-300 w-screen h-auto min-h-screen pb-10">
    <div class="flex flex-col w-2/3 mx-auto bg-grey-academy-300"
      v-if="hasNotifications">
      <div>
        <div class="flex justify-start rounded-sm text-lg p-4 mx-3" role="group">
          <button
            @click="setNotificationsFilter('all')"
            :class="notificationsFilter === 'all' ? 'font-bold' : ''"
            class="text-gray-300 hover:font-bold mr-4 font-light
              outline-none focus:shadow-outline uppercase"
          >
            {{$t('messages.all')}}
          </button>
          <button
            @click="setNotificationsFilter('toRead')"
            :class="notificationsFilter === 'toRead' ? 'font-bold' : ''"
            class="text-gray-300 hover:font-bold font-light
              outline-none focus:shadow-outline uppercase"
          >
            {{$t('messages.toread')}}
          </button>
        </div>
        <notification-container
          v-for="notification in notificationsFiltered"
          :key="notification.id"
          :notification="notification"
        ></notification-container>
      </div>
    </div>
    <div v-else>
      <no-notifications>
        <template v-slot:title>
          <h2 class="text-xl lg:text-2xl">
            {{$t('notifications.noNotificationsStudent')}}
           </h2>
        </template>
      </no-notifications>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NoNotifications from '../notifications/NoNotifications.vue';
import NotificationContainer from '../notifications/NotificationContainer.vue';

export default {
  components: { NotificationContainer, NoNotifications },
  data() {
    return {
      notificationsFilter: 'all',
    };
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('notifications', ['hasNotifications', 'notificationsByUserType']),
    notificationsFiltered() {
      switch (this.notificationsFilter) {
        case 'toRead':
          return this.notificationsByUserType.filter((notification) => !notification.read_at);
        default:
          return this.notificationsByUserType;
      }
    },
  },
  created() {
    this.getNotifications();
  },
  methods: {
    ...mapActions({
      getNotifications: 'notifications/getNotifications',
    }),
    setNotificationsFilter(filter) {
      this.notificationsFilter = filter;
    },
  },
};
</script>
